import bem from 'utils/bem';

export const block = bem('edit-automation-episode-select-season');
